import { useState } from "react";
import PropTypes from "prop-types";

import Popover from "@mui/material/Popover";
import TableRow from "@mui/material/TableRow";
import MenuItem from "@mui/material/MenuItem";
import TableCell from "@mui/material/TableCell";
import IconButton from "@mui/material/IconButton";
import Iconify from "../../../components/iconify/iconify";
import ImageWithFallback from "../../../components/ImageWithFallback";

// ----------------------------------------------------------------------

// Format as "15 February, 2025"
const formatBoardDate = (date) => {
  if (!date) return "—";
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return "—";
  const day = d.getDate();
  const month = d.toLocaleDateString("en-US", { month: "long" });
  const year = d.getFullYear();
  return `${day} ${month}, ${year}`;
};

export default function UserTableRow({
  selected,
  rowNumber,
  row,
  name,
  title,
  image,
  startDate,
  endDate,
  onDelete,
  onEdit,
  onEndTerm,
  onMakeCurrent,
  handleClick,
}) {
  const [open, setOpen] = useState(null);
  const isCurrent = row && !row.endDate;

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  return (
    <>
      <TableRow hover tabIndex={-1} selected={selected}>
        <TableCell
          sx={{
            fontSize: { xs: "0.75rem", sm: "0.875rem" },
            padding: { xs: "8px 4px", sm: "16px" },
            width: { md: "5%" },
            fontWeight: 500,
          }}
        >
          {rowNumber}
        </TableCell>
        <TableCell>{name}</TableCell>
        <TableCell>{title}</TableCell>
        <TableCell>
          <ImageWithFallback path={image} alt="" style={{ width: 100 }} />
        </TableCell>
        <TableCell>{formatBoardDate(startDate)}</TableCell>
        <TableCell>{formatBoardDate(endDate)}</TableCell>
        <TableCell>
          {isCurrent ? (
            <span style={{ color: "#2e7d32", fontWeight: 600 }}>Current</span>
          ) : (
            <span style={{ color: "#666" }}>Past</span>
          )}
        </TableCell>
        <TableCell align="right">
          <IconButton onClick={handleOpenMenu}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>

      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ sx: { width: 180 } }}
      >
        <MenuItem onClick={onEdit}>
          <Iconify icon="eva:edit-fill" sx={{ mr: 2 }} />
          Edit
        </MenuItem>
        {isCurrent && onEndTerm && (
          <MenuItem onClick={onEndTerm}>
            <Iconify icon="eva:calendar-outline" sx={{ mr: 2 }} />
            End term
          </MenuItem>
        )}
        {!isCurrent && onMakeCurrent && (
          <MenuItem onClick={onMakeCurrent}>
            <Iconify icon="eva:refresh-outline" sx={{ mr: 2 }} />
            Make current
          </MenuItem>
        )}
        <MenuItem onClick={onDelete} sx={{ color: "error.main" }}>
          <Iconify icon="eva:trash-2-outline" sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}

UserTableRow.propTypes = {
  row: PropTypes.object,
  rowNumber: PropTypes.number,
  name: PropTypes.any,
  title: PropTypes.any,
  image: PropTypes.any,
  startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  onEndTerm: PropTypes.func,
  onMakeCurrent: PropTypes.func,
  handleClick: PropTypes.func,
  selected: PropTypes.any,
};
